import { render, staticRenderFns } from "./JdpCompanySettings.vue?vue&type=template&id=31bc0f2e&scoped=true&"
import script from "./JdpCompanySettings.vue?vue&type=script&lang=ts&"
export * from "./JdpCompanySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc0f2e",
  null
  
)

export default component.exports